import portfolioData from '../../data/portfolioData';
import Reveal from '../Reveal/Reveal';
import './Skills.css';

const Skills = () => (
  <section className="section skills" id="skills">
    <div className="container">
      <Reveal>
        <div className="section-head">
          <p className="section-eyebrow">Technical skills</p>
          <h2 className="section-title">Tools I use to ship</h2>
          <p className="section-lead">
            A practical stack spanning mobile, web, backend systems, and AI product features.
          </p>
        </div>
      </Reveal>

      <div className="skills__grid">
        {portfolioData.skills.map((group, index) => (
          <Reveal key={group.title} delay={(index % 3) + 1}>
            <article className="skills__group">
              <h3>{group.title}</h3>
              <ul>
                {group.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Skills;
